/*TODO: Mobile css needed*/

:host {
  display: block;
  font-size: 14px;
  color: var(--color-dark-gray);
}

footer {
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;
}

a {
  color: var(--color-link-blue);
  text-decoration: none;
  font-weight: var(--font-weight-bold);
}
a:hover {
  color: var(--color-cwru-blue);
  text-decoration: underline;
}
.footer-header {
  font-weight: var(--font-weight-semibold);
  font-size: 18px;
  margin: 0 0 12px;
  padding: 0;
  text-transform: uppercase;
  color: var(--color-black);
}
.footer-double {
  background: var(--color-black);
  color: var(--color-white);
}
.footer-double p a {
  color: var(--color-white);
  text-decoration: underline;
}

/***** Footer university info block *****/
.footer-university-block, .footer-university-block-double {
  font-size: 14px;
}
.footer-university-block-double {
  display: flex;
  align-items: flex-start;
}
.footer__logo {
  margin-bottom: 10px;
  max-width: 254px;
}
.footer-university-block p, .footer-university-block-double p {
  margin: 0;
  line-height: 2;
}
address.case-address {
  font-style: normal;
  line-height: 2;
}

.switcher cwru-footer-dept-info {
  flex-grow: 2;
}

/***** Footer Department info block *****/
.footer-dept-info {
  display: flex;
  align-items: flex-start;
}
.footer-map-icon {
  width: 28px;
  margin-right: 26px;
  height: auto;
  overflow: hidden;
}
p.contact {
  font-weight: var(--font-weight-semibold);
}

/*****Footer social media block & links*****/
.footer__social-icons {
  display: flex;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  text-transform: capitalize;
}

.footer__social-icon {
  width: 38px;
  height: 38px;
  font-size: 21px;
  font-weight: normal;
  margin: 0 8px 8px 0;
  /*padding-top: 8px;*/
  border-radius: 100%;
  text-align: center;
  display: inline-block;
  background-color: var(--color-cwru-blue) !important;
  color: #fff;
  transition: background-color 0.2s;
  text-decoration: none;
}
.footer__social-icon:hover {
  background-color: var(--color-link-blue) !important;
}
.footer__social-icon img {
  width: 22px;
  height: 22px;
  vertical-align: middle;
  padding-top: 4px;
  color: #fff !important;
  fill: white !important;
  stroke: white;
}


/*****Footer cwru links*****/
.footer-links ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.footer-links ul li {
  display: block;
  line-height: 2;
  margin: 0;
  padding: 0;
}
cwru-footer-links {
  max-width: 130px;
}

@media (max-width: 900px) {
  .footer-map-icon {
    display: none;
  }
}


/***** Footer Double *****/
.footer-double .footer-university-block {
  display: flex;

}